const planTypeMap: Record<ChargebeePlanId, PaymentPlanType> = {
    CHARGEBEE_PLAN_BASIC: 'basic',
    CHARGEBEE_PLAN_CATALOG_ANALYSIS: 'catalogAnalysis',
    CHARGEBEE_PLAN_LITE: 'lite',
    CHARGEBEE_PLAN_NEW_BASIC: 'basic',
    CHARGEBEE_PLAN_NEW_PRO: 'pro',
    CHARGEBEE_PLAN_PRO: 'pro',
    CHARGEBEE_PLAN_RISE: 'rise',
    CHARGEBEE_PLAN_SCALE: 'scale',
    CHARGEBEE_PLAN_TRIAL: 'freeTrial',
    CHARGEBEE_PLAN_PUBLISHER: 'publisher',
};

export const getPlanType = (
    planId: ChargebeePlanId | null,
): PaymentPlanType | null => {
    if (planId === null) {
        return null;
    }

    return planTypeMap[planId];
};
